import { Button } from '@dfh-corp-sites/ui'
import React, { useMemo, useState } from 'react'

import { GetCustomerCartQuery } from '../../graphql/magento'
import { readCartDispensaryPromoCodes } from '../../lib/cart/dispensary-promo'
import { totalQuantityExcludingDependents } from '../../lib/cart/item'
import { CartState, ToggleCodesAction } from '../../lib/cart/reducers/cart-state'
import { PlusMinusIcon } from '../PlusMinusIcon'
import AddPromoCode from './AddPromoCode'
import AppliedPromoCode from './AppliedPromoCode'

export interface CartPromoCodeProps extends Pick<CartState, 'codesCollapsed' | 'formDisabled'> {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  dispatch: React.Dispatch<ToggleCodesAction>
}

const CartPromoCode: React.FC<CartPromoCodeProps> = ({
  cart,
  codesCollapsed,
  formDisabled,
  dispatch,
}) => {
  const [showPromoInput, setShowPromoInput] = useState(false)

  const {
    applied_coupons: appliedCoupons,
    id: cartId,
    items,
    dispensary_promo_code: dispensaryPromoCode,
    total_quantity: totalQuantity,
  } = cart

  const cartDispensaryPromoCodes = useMemo(
    () => (dispensaryPromoCode ? readCartDispensaryPromoCodes(dispensaryPromoCode) : undefined),
    [dispensaryPromoCode],
  )

  const cartTotalQuantity = totalQuantityExcludingDependents(items, totalQuantity)

  const togglePromoInput = () => {
    setShowPromoInput((prev) => !prev)
  }

  return (
    <div>
      <div className="border-b border-t border-brand-rule-grey">
        {!showPromoInput && (
          <div className="flex justify-center items-center py-3">
            <Button
              variant="text"
              size="sm"
              onClick={togglePromoInput}
              className="small-paragraph-text"
            >
              <PlusMinusIcon className="size-4" />
              Add Promo Code
            </Button>
          </div>
        )}
        {showPromoInput && (
          <AddPromoCode
            cartDispensaryPromoCodes={cartDispensaryPromoCodes}
            cartId={cartId}
            formDisabled={formDisabled}
            isEmptyCart={cartTotalQuantity === 0}
          />
        )}
        {!!appliedCoupons?.length && (
          // disable gutter since toggle button adds 10px padding to increase touch target
          <div className="flex px-5">
            <AppliedPromoCode
              appliedCoupons={appliedCoupons}
              cartDispensaryPromoCodes={cartDispensaryPromoCodes}
              cartId={cartId}
              codesCollapsed={codesCollapsed}
              dispatch={dispatch}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default CartPromoCode
